export default {
  validateAlert: 'validateAlert',
  addRoamItemAlert: 'addRoamItemAlert',
  switchDataRoamingAlert: 'switchDataRoamingAlert',
  countryRoamingAlert: 'countryRoamingAlert',
  progress: 'progress',
  progressClose: 'progressClose',
  progressValue: 'progressValue',
};




// WEBPACK FOOTER //
// ./src/event-bus/event.js